<template>
  <BgImageLayout title="Custom forms" :page="__guide.forms" icon-color="white">
    <AgGridWrapper
      :options="gridOptions"
      :include-search-box="true"
      :actions="[
        {
          routeName: 'create-form',
          label: 'Create new Form',
          type: 'route',
          size: 'md'
        }
      ]"
      store-namespace="forms"
    />
  </BgImageLayout>
</template>

<script>
import { dateRenderer, dateSorter, entityNameSorter, getProp } from '@/lib/generic.utils'
import * as apiTo from '@/modular-api'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'
import LmEntityActions from '@components/ag-grid-helpers/EntityActions'
import LmGridEntityLink from '@components/ag-grid-helpers/EntityLink'
import { deleteAgGridRow } from '@/reusable/ConfirmationDialog/delete-ag-grid-row'

export default {
  components: {
    AgGridWrapper
  },

  data() {
    return {
      forms: null
    }
  },

  computed: {
    gridOptions() {
      return {
        rowData: this.forms,
        context: {
          actions: [
            {
              icon: 'trash',
              tooltip: 'Delete',
              onClick: this.delete,
              color: 'faded'
            }
          ]
        },
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            cellRendererParams: params => {
              if (!params || !params.value) return
              return {
                customData: {
                  id: params.data.id,
                  routeName: 'form',
                  label: params.value,
                  newTab: false
                }
              }
            },
            cellRendererFramework: LmGridEntityLink
          },
          {
            headerName: 'Type',
            field: 'type',
            tooltipField: 'type'
          },
          {
            headerName: 'Product Type',
            field: 'product_type',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'name'),
            tooltipValueGetter: params => getProp(params.value, 'name')
          },
          {
            headerName: 'Product Name',
            field: 'product',
            comparator: entityNameSorter,
            cellRendererParams: params => {
              if (!params || !params.value) return
              return {
                customData: {
                  id: getProp(params.value, 'id'),
                  routeName: 'product',
                  label: getProp(params.value, 'name'),
                  newTab: false
                }
              }
            },
            cellRendererFramework: LmGridEntityLink,
            tooltipValueGetter: params => getProp(params.value, 'name')
          },
          {
            headerName: 'Created On',
            field: 'created_at',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Created By',
            field: 'created_by',
            tooltipField: 'created_by'
          },
          {
            headerName: 'Actions',
            field: 'id',
            cellRendererFramework: LmEntityActions
          }
        ]
      }
    }
  },

  created() {
    this.getForms()
  },

  methods: {
    getForms() {
      apiTo.GET_CUSTOM_FORMS().then(({ data }) => (this.forms = data.result))
    },

    delete(params) {
      deleteAgGridRow(params, 'GET_CUSTOM_FORM_DELETE_CONFIRMATION', 'DELETE_CUSTOM_FORM', () => {
        const index = this.forms.findIndex(f => f.id === params.data.id)
        if (~index) this.forms.splice(index, 1)
      })
    }
  }
}
</script>
